import { _ as _assert_this_initialized } from "@swc/helpers/_/_assert_this_initialized";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _get } from "@swc/helpers/_/_get";
import { _ as _get_prototype_of } from "@swc/helpers/_/_get_prototype_of";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _create_super } from "@swc/helpers/_/_create_super";
import { State } from "../../State";
import { DEFAULT_TOUCH_SLOP } from "../constants";
import GestureHandler from "./GestureHandler";
import ScaleGestureDetector from "../detectors/ScaleGestureDetector";
var PinchGestureHandler = /*#__PURE__*/ function(GestureHandler) {
    "use strict";
    _inherits(PinchGestureHandler, GestureHandler);
    var _super = _create_super(PinchGestureHandler);
    function PinchGestureHandler() {
        _class_call_check(this, PinchGestureHandler);
        var _this;
        _this = _super.apply(this, arguments);
        _define_property(_assert_this_initialized(_this), "scale", 1);
        _define_property(_assert_this_initialized(_this), "velocity", 0);
        _define_property(_assert_this_initialized(_this), "startingSpan", 0);
        _define_property(_assert_this_initialized(_this), "spanSlop", DEFAULT_TOUCH_SLOP);
        _define_property(_assert_this_initialized(_this), "scaleDetectorListener", {
            onScaleBegin: function(detector) {
                _this.startingSpan = detector.getCurrentSpan();
                return true;
            },
            onScale: function(detector) {
                var prevScaleFactor = _this.scale;
                _this.scale *= detector.getScaleFactor(_this.tracker.getTrackedPointersCount());
                var delta = detector.getTimeDelta();
                if (delta > 0) {
                    _this.velocity = (_this.scale - prevScaleFactor) / delta;
                }
                if (Math.abs(_this.startingSpan - detector.getCurrentSpan()) >= _this.spanSlop && _this.currentState === State.BEGAN) {
                    _this.activate();
                }
                return true;
            },
            onScaleEnd: function(_detector) {}
        });
        _define_property(_assert_this_initialized(_this), "scaleGestureDetector", new ScaleGestureDetector(_this.scaleDetectorListener));
        return _this;
    }
    _create_class(PinchGestureHandler, [
        {
            key: "init",
            value: function init(ref, propsRef) {
                _get(_get_prototype_of(PinchGestureHandler.prototype), "init", this).call(this, ref, propsRef);
                this.setShouldCancelWhenOutside(false);
            }
        },
        {
            key: "updateGestureConfig",
            value: function updateGestureConfig(_param) {
                var _param_enabled = _param.enabled, enabled = _param_enabled === void 0 ? true : _param_enabled, props = _object_without_properties(_param, [
                    "enabled"
                ]);
                _get(_get_prototype_of(PinchGestureHandler.prototype), "updateGestureConfig", this).call(this, _object_spread({
                    enabled: enabled
                }, props));
            }
        },
        {
            key: "transformNativeEvent",
            value: function transformNativeEvent() {
                return {
                    focalX: this.scaleGestureDetector.getFocusX(),
                    focalY: this.scaleGestureDetector.getFocusY(),
                    velocity: this.velocity,
                    scale: this.scale
                };
            }
        },
        {
            key: "onPointerDown",
            value: function onPointerDown(event) {
                this.tracker.addToTracker(event);
                _get(_get_prototype_of(PinchGestureHandler.prototype), "onPointerDown", this).call(this, event);
            }
        },
        {
            key: "onPointerAdd",
            value: function onPointerAdd(event) {
                this.tracker.addToTracker(event);
                _get(_get_prototype_of(PinchGestureHandler.prototype), "onPointerAdd", this).call(this, event);
                this.tryBegin();
                this.scaleGestureDetector.onTouchEvent(event, this.tracker);
            }
        },
        {
            key: "onPointerUp",
            value: function onPointerUp(event) {
                _get(_get_prototype_of(PinchGestureHandler.prototype), "onPointerUp", this).call(this, event);
                this.tracker.removeFromTracker(event.pointerId);
                if (this.currentState !== State.ACTIVE) {
                    return;
                }
                this.scaleGestureDetector.onTouchEvent(event, this.tracker);
                if (this.currentState === State.ACTIVE) {
                    this.end();
                } else {
                    this.fail();
                }
            }
        },
        {
            key: "onPointerRemove",
            value: function onPointerRemove(event) {
                _get(_get_prototype_of(PinchGestureHandler.prototype), "onPointerRemove", this).call(this, event);
                this.scaleGestureDetector.onTouchEvent(event, this.tracker);
                this.tracker.removeFromTracker(event.pointerId);
                if (this.currentState === State.ACTIVE && this.tracker.getTrackedPointersCount() < 2) {
                    this.end();
                }
            }
        },
        {
            key: "onPointerMove",
            value: function onPointerMove(event) {
                if (this.tracker.getTrackedPointersCount() < 2) {
                    return;
                }
                this.tracker.track(event);
                this.scaleGestureDetector.onTouchEvent(event, this.tracker);
                _get(_get_prototype_of(PinchGestureHandler.prototype), "onPointerMove", this).call(this, event);
            }
        },
        {
            key: "onPointerOutOfBounds",
            value: function onPointerOutOfBounds(event) {
                if (this.tracker.getTrackedPointersCount() < 2) {
                    return;
                }
                this.tracker.track(event);
                this.scaleGestureDetector.onTouchEvent(event, this.tracker);
                _get(_get_prototype_of(PinchGestureHandler.prototype), "onPointerOutOfBounds", this).call(this, event);
            }
        },
        {
            key: "tryBegin",
            value: function tryBegin() {
                if (this.currentState !== State.UNDETERMINED) {
                    return;
                }
                this.resetProgress();
                this.begin();
            }
        },
        {
            key: "activate",
            value: function activate(force) {
                if (this.currentState !== State.ACTIVE) {
                    this.resetProgress();
                }
                _get(_get_prototype_of(PinchGestureHandler.prototype), "activate", this).call(this, force);
            }
        },
        {
            key: "onReset",
            value: function onReset() {
                this.resetProgress();
            }
        },
        {
            key: "resetProgress",
            value: function resetProgress() {
                if (this.currentState === State.ACTIVE) {
                    return;
                }
                this.velocity = 0;
                this.scale = 1;
            }
        }
    ]);
    return PinchGestureHandler;
}(GestureHandler);
export { PinchGestureHandler as default };
